import { DossierSearchActionTypes } from '@app/pcs/actions/dossier-search';
import { BackButtonActions, BackButtonActionTypes, SetCurrentDossier } from '@dossier/actions/back-button';
import { createHandler, createReducer, persistReducer, reducerWithResetAction } from '@util';
import * as R from 'ramda';

interface Dossier {
  dossierId: number;
  title: string;
}

export interface State {
  dossiers: Dossier[];
  currentIndex: number;
}

export const initialState: State = {
  dossiers: [],
  currentIndex: null
};

type GetAllDossiers = (s: State) => Dossier[];
export const getAllDossiers: GetAllDossiers = R.prop('dossiers');

type GetCurrentIndex = (s: State) => number;
export const getCurrentIndex: GetCurrentIndex = R.prop('currentIndex');

const setCurrentDossierIndex = (state: State, {payload: dossierId}: SetCurrentDossier): State => {
  const currentIndex = R.findIndex(R.propEq('dossierId', dossierId), state.dossiers);

  return R.mergeRight(state, {
    currentIndex
  });
};

const setCurrentDossierIndexHandler = createHandler(
  BackButtonActionTypes.SetCurrentDossier,
  setCurrentDossierIndex
);

export const reducer = persistReducer<State, Dossier[]>(
  {
    storageKey: 'dashboard',
    mergeStates: (state: State, dossiers: Dossier[]): State => R.mergeRight(state, {dossiers}),
    shouldSync: R.F,
    shouldReinitialize: (_, action) => action.type === DossierSearchActionTypes.SearchDossiersSuccess
  },
  reducerWithResetAction(BackButtonActionTypes.ResetState,
    createReducer<State, BackButtonActions>([
      setCurrentDossierIndexHandler
    ], initialState)
  )
);

